// extracted by mini-css-extract-plugin
export default {"table-title":"BasicInfo_table-title_fPhPw"};